module.exports = __webpack_public_path__ + "img/flatwhite.77941136.png";